export default "__VITE_ASSET__Cw_Gvypw__"